import { atom, atomFamily } from "recoil";

import { MapRouteBlockTypeEnum, MapViewModeEnum } from "../../enums";
import {
  IShownAreaPolygon,
  IStationsBulkActionTarget,
  StationsBulkActionSourceEnum,
} from "../../models";

export const autoFitMapAF = atomFamily<boolean, MapRouteBlockTypeEnum>({
  key: "autoFitMapAtom",
  default: true,
});

export const mapViewModeAF = atomFamily<MapViewModeEnum, MapRouteBlockTypeEnum>(
  {
    key: "mapViewModeAtom",
    default: MapViewModeEnum.All,
  },
);

export const routeColorIdMatchesAtom = atom<Map<number, number>>({
  key: "routeColorIdMatchesAtom",
  default: new Map(),
});

export const isRenderPolylineAllowedAtom = atom<boolean>({
  key: "isRenderPolilyneAllowedAtom",
  default: true,
});

/**
 * Area polygons currently shown on the stations map, keyed by areaId. Shared across all
 * station popups so the same area's polygon (and its color) is reflected on every station
 * that belongs to it — letting the user notice an area's polygon is already displayed.
 */
export const shownAreaPolygonsAtom = atom<Record<number, IShownAreaPolygon>>({
  key: "shownAreaPolygonsAtom",
  default: {},
});

/** Station ids highlighted (selected) on the stations map — via marker click or draw-select. */
export const stationsMapSelectedIdsAtom = atom<number[]>({
  key: "stationsMapSelectedIdsAtom",
  default: [],
});

/** Which station selection (grid checkboxes vs map markers) bulk actions should target. */
export const stationsBulkActionTargetAtom = atom<IStationsBulkActionTarget>({
  key: "stationsBulkActionTargetAtom",
  default: {
    source: StationsBulkActionSourceEnum.checkbox,
    stationIds: [],
  },
});

/** Whether the stations-map bulk-action target panel is open (rendered outside the Leaflet map). */
export const stationsMapBulkPanelOpenAtom = atom<boolean>({
  key: "stationsMapBulkPanelOpenAtom",
  default: false,
});
